import axios from 'axios';

const BASE_USERS_URL = '/users';
const SIGN_UP_URL = '/users/sign_up';

export function findAll(accountID, page_number, searchQuery) {
  return axios.get(
    `${BASE_USERS_URL}?account_id=${accountID}&page_number=${page_number}&limit=10&q=${searchQuery}`,
    {}
  );
}

export function getUsers(params) {
  return axios.get(`${BASE_USERS_URL}`, { params: params });
}

export function deleteUser(userId) {
  return axios.delete(`${BASE_USERS_URL}/${userId}`);
}

// TODO hay que cambiar este end point para que al crear usuarios no se haga como si fuera un registro si no como un create users
export function add(params) {
  return axios.post(`${SIGN_UP_URL}`, params);
}

export function refresh_api_key(userId) {
  return axios.post(`${BASE_USERS_URL}/${userId}/api_key`);
}

// BSSP-1906: fetch the caller's OWN cleartext api_key on demand (self-only,
// no :id in the path). Replaces carrying the key in the login payload.
export function getOwnApiKey() {
  return axios.get(`${BASE_USERS_URL}/me/api_key`);
}

export function logAsUser(userId) {
  return axios.post(`${BASE_USERS_URL}/${userId}/log_as_user`);
}

export function exitLogAsUser() {
  return axios.post(`${BASE_USERS_URL}/exit_log_as_user`);
}
